import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import KeyboardingAssessments from './KeyboardingAssessments';
import Enrichment from './Enrichment';
import GET_KEYBOARDING_CLASSROOM_SETTINGS from 'graph/settings/key/get-keyboarding-classroom-settings-query';
import { Classroom } from 'types/schema-generated-types';
import { Typography } from '@material-ui/core';
import AssessmentAccelerator from './AssessmentAccelerator';

interface KeyboardingSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomKeyboardAddonGroupSettings: FC<KeyboardingSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading, refetch } = useQuery(GET_KEYBOARDING_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    },
    // TODO: Using network-only here to avoid caching because some classroom and student level settings (mostly Home Access)
    // are dependent/derived from one another. In other words, changing the setting at one level will affect the setting at the
    // other level. Figuring out the required cache updates to keep these synced this seemed tricky, so avoiding the cache
    // altogether for now.
    fetchPolicy: 'network-only'
  });

  return (
    <PageContainer loading={loading}>
      <Typography variant="h3">Curriculum Add-ons</Typography>
      <AssessmentAccelerator
        classroom={classroom}
        expanded={expanded}
        setting={data?.keyClassroomSettings.assessmentAcceleratorSettings}
        handleChangeExpanded={handleChangeExpanded}
        refetch={refetch}
      />
      <Enrichment
        classroom={classroom}
        expanded={expanded}
        myChoiceKeyboarding={
          data?.keyClassroomSettings.enrichmentActivitySettings?.myChoiceKeyboarding
        }
        hearItTypeIt={data?.keyClassroomSettings.enrichmentActivitySettings?.hearItTypeIt}
        teacherCreated={data?.keyClassroomSettings.enrichmentActivitySettings?.teacherCreated}
        handleChangeExpanded={handleChangeExpanded}
      />
      <KeyboardingAssessments
        classroom={classroom}
        expanded={expanded}
        setting={data?.keyClassroomSettings.assessmentSettings}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomKeyboardAddonGroupSettings;
